<!-- 由 suu 创建于 2022-06-22 Wednesday -->
<template>
  <div class="ques-gender">
    <div class="gender-title">{{ curQues.field_title }}</div>
    <div class="gender-list">
      <div
        class="gender-item"
        @click="handelClick(item.key)"
        v-for="(item, index) in curQues.field_unit"
        :key="index"
      >
        <img
          class="i-img"
          :src="
            item.key == value ? gender[item.key].imgAc : gender[item.key].img
          "
          alt=""
        />
        <div class="i-text" :class="{ 'i-text-ac': item.key == value }">
          {{ item.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ques-gender',

  components: {},

  props: {
    curQues: {}
  },

  data() {
    return {
      gender: {
        男: {
          img: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-man',
          imgAc: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-man-s'
        },
        女: {
          img: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-women',
          imgAc:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-women-s'
        }
      },
      value: '' //当前选择选项的的key
    }
  },

  computed: {},

  watch: {},

  created() {
    this.value = this.curQues.value
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 选择性别
    handelClick(key) {
      this.value = key
      this.$emit('change', { value: key })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ques-gender {
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .gender-title {
    font-size: 22px;
    font-weight: 600;
    color: #202539;
    line-height: 32px;
  }
  .gender-list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 70px;
    .gender-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      .i-img {
        width: 104px;
        height: 104px;
      }
      .i-text {
        font-size: 20px;
        font-weight: 500;
        color: #697387;
        line-height: 21px;
        margin-top: 18px;
      }
      .i-text-ac {
        color: #373d52;
      }
    }
    .gender-item + .gender-item {
      margin-left: 42px;
    }
  }
}
</style>
